import _ from 'lodash'

const defaultFilter = {
  showPickups: true,
  showClosed: true,
  foodType: null
}

const state = {
  filter: _.merge({}, defaultFilter)
}

const getters = {
  locationFilter: state => state.filter
}

const actions = {
  resetLocationFilter ({ commit }) {
    commit('setFilter', defaultFilter)
  }
}

const mutations = {
  setFilter (state, val) {
    state.filter = val
  },

  updateShowPickupsFilter (state, val) {
    state.filter.showPickups = val
  },

  updateShowClosedFilter (state, val) {
    state.filter.showClosed = val
  },

  updateFoodTypeFilter (state, val) {
    state.filter.foodType = val
  }
}

export default {
  actions,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/location.js